<template>
  <div class="profile-picture-wrap nowrap">
    <slot v-if="!loadedImage" />
    <img
      v-show="loadedImage"
      :class="{ blur: loading }"
      :src="url"
      class="img-circle profile-picture"
      alt="Profile Picture"
      @load="load"
    />
    <BaseHtmlForm
      v-if="isMe"
      ref="form"
      method="PATCH"
      action="/profile/avatar"
      enctype="multipart/form-data"
      append-user-and-account
    >
      <label v-if="!loading">
        <i class="zmdi zmdi-camera" />
        {{ $t('Update') }}
        <input
          ref="input"
          accept="image/gif, image/jpeg, image/png"
          name="avatar"
          type="file"
          style="display: none"
          @change="submit"
        />
      </label>
      <div
        v-if="loading"
        style="position: absolute; height: 130px; top: 0; padding-top: 40px; padding-left: 20px"
      >
        <!-- eslint-disable-next-line vue/no-undef-components -- Baseline eslint ignore please fix if working on this-->
        <NetworkLoader :loader="loading" />
      </div>
    </BaseHtmlForm>
  </div>
</template>

<script>
import axios from 'axios'
import ax from '@/api/axios-instance'
import enums from '@/utils/enum'
import { SET_EDIT_UNSAVED } from '@/state/mutation-types'
import BaseHtmlForm from '@/components/BaseHtmlForm.vue'

export default {
  name: 'EditProfileImage',
  components: { BaseHtmlForm },
  props: {
    isMe: { required: true, type: Boolean },
    accountId: { required: true, type: String },
  },
  data() {
    return {
      timestamp: Date.now(),
      loading: false,
      loadedImage: false,
      url: '',
    }
  },
  created() {
    this.ax = axios.create({
      baseURL: '',
      headers: { ...ax.headers, ...{ accept: 'application/json' } },
    })
  },
  methods: {
    err() {
      this.$store.commit('sendNotification', {
        type: enums.notification.types.ERROR,
        sender: this,
        severity: enums.notification.severity.CRITICAL,
      })
    },
    load() {
      this.loadedImage = true
      this.loading = false
      this.$store.commit(SET_EDIT_UNSAVED, false)
    },
    async submit() {
      if (this.loading) return
      this.loading = true
      const app = this
      const data = new FormData(this.$refs.form.$refs.htmlForm)
      this.$store.commit(SET_EDIT_UNSAVED, true)
      try {
        await this.ax
          .post('/profile/avatar', data)
          .then((x) => {
            this.url = x.data.url
          })
          .then(() => {
            this.loading = false
            $('.desaturate.dimmed.user-picture').attr('src', this.url)
          })
        app.timestamp = Date.now()
      } catch (e) {
        app.loading = false
        app.$store.commit(SET_EDIT_UNSAVED, true)
        this.err()
      }
    },
  },
}
</script>

<style scoped lang="scss">
.blur {
  filter: blur(3px);
}

.profile-picture-wrap {
  position: relative;
  height: 130px;
  width: 130px;
  border-radius: 50%;
  :deep(.profile-picture) {
    width: 130px;
    height: 130px;
    margin-top: 0;
  }
  label {
    margin-top: 0;
    cursor: pointer;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 50%;
    height: 130px;
    width: 130px;
    position: absolute;
    overflow: hidden;
    color: #fff;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    line-height: 130px;
    display: none;
    top: 0;
    left: 0;
    right: auto;
  }
  &:hover label {
    display: block;
  }
}
</style>
